module.exports = __webpack_public_path__ + "media/BANK.bc07caff.mp3";